import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Toolbar from '@mui/material/Toolbar';
import Link from '@mui/material/Link';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import NavigationDropdown from './NavigationDropdown';
import NavigationButton from './NavigationButton';

const NavigationBar = ({ items, isLoading }) => {
	const { pathname } = useLocation();

	return (
		<Box
			sx={{
				bgcolor: 'background.eveCustom.secondary',
				mt: '2px',
			}}
		>
			<Container
				maxWidth={pathname === '/' ? false : 'xl'}
				sx={{ px: 1 }}
			>
				<Toolbar
					role='navigation'
					disableGutters
					sx={{
						minHeight: { sm: '48px' },
						px: { xs: 0, sm: 0, md: 4 },
						ml: '3px',
						gap: 5,
					}}
				>
					{isLoading && (
						<Stack
							direction='row'
							spacing={2}
							role='progressbar'
							aria-label='Loading'
						>
							<Skeleton
								variant='rectangle'
								height={48}
								width={100}
							/>
							<Skeleton
								variant='rectangle'
								height={48}
								width={100}
							/>
							<Skeleton
								variant='rectangle'
								height={48}
								width={100}
							/>
							<Skeleton
								variant='rectangle'
								height={48}
								width={100}
							/>
							<Skeleton
								variant='rectangle'
								height={48}
								width={100}
							/>
						</Stack>
					)}
					{!isLoading &&
						items.map(item => {
							if (item.isDropdown) {
								return (
									<NavigationDropdown
										key={item.key}
										buttonKey={item.key}
										buttonLabel={item.label}
										menuItems={item.menuItems}
									/>
								);
							}
							return (
								<NavigationButton
									key={item.key}
									activeKey={item.path}
									{...(item.isLegacy
										? {
												component: Link,
												href: item.path,
												target: item.isExternal
													? '_blank'
													: '_self',
												rel: 'noreferrer',
										  }
										: {
												component: RouterLink,
												to: item.path,
										  })}
								>
									{item.label}
								</NavigationButton>
							);
						})}
				</Toolbar>
			</Container>
		</Box>
	);
};

NavigationBar.propTypes = {
	items: PropTypes.array.isRequired,
	isLoading: PropTypes.bool,
};
NavigationBar.defaultProps = {
	isLoading: false,
};

export default NavigationBar;
